module.exports = __webpack_public_path__ + "media/images/balance-people-employees-f244e8e0dcc8c3a1b1674f3227d91e37.png";